export default function KPICard({ label, value, badge, badgeColor = 'var(--color-accent)', icon, onClick }) {
  return (
    <div
      style={{
        background: 'var(--color-card)',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius-lg)',
        padding: '20px 22px',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'box-shadow 0.15s',
        position: 'relative',
      }}
      onClick={onClick}
      onMouseEnter={e => onClick && (e.currentTarget.style.boxShadow = 'var(--shadow-sm)')}
      onMouseLeave={e => onClick && (e.currentTarget.style.boxShadow = 'none')}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <p style={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--color-text-secondary)', marginBottom: 8 }}>
            {label}
          </p>
          <p style={{ fontSize: 36, fontWeight: 700, color: 'var(--color-text)', lineHeight: 1 }}>
            {value ?? '—'}
          </p>
        </div>
        <div style={{ fontSize: 28, opacity: 0.4 }}>{icon}</div>
      </div>
      {badge != null && badge > 0 && (
        <span style={{
          position: 'absolute',
          top: 16,
          right: 16,
          padding: '2px 8px',
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 700,
          background: badgeColor,
          color: '#fff',
        }}>
          {badge}
        </span>
      )}
    </div>
  );
}
